/**
 * Author：brand
 * Creation Time：2019-06-13 10:03
 * Email：brandhuang@qq.com
 */
import ax from '../../axios'

/**
 * 会话分配相关       ⬇
 * @param params
 */
export function getRulesAPI (params) {
  return ax({
    url: '/wlapi/sessionDis/getSessionDis',
    method: 'GET',
    params
  })
}

export function getConfigAPI (params) {
  return ax({
    url: '/wlapi/automsgsetting/getAutoSet',
    method: 'GET',
    params
  })
}
export function saveConfigAPI (params) {
  return ax({
    url: '/wlapi/automsgsetting/automaticMessage',
    method: 'GET',
    params
  })
}

export function getServiceSortAPI (params) {
  return ax({
    url: '/wlapi/sessionDis/getCsSort',
    method: 'GET',
    params
  })
}
export function saveServiceSortAPI (params) {
  return ax({
    url: '/wlapi/sessionDis/saveSorts',
    method: 'POST',
    data:params
  })
}

export function saveServiceTimeAPI (params) {
  return ax({
    url: '/wlapi/sessionDis/saveCsWorkTime',
    method: 'POST',
    params
  })
}
export function saveServiceSortRulesAPI (params) {
  return ax({
    url: '/wlapi/sessionDis/saveCsAssign',
    method: 'POST',
    params
  })
}

/**
 * 基础设置相关   ⬇
 * @param params
 */

export function getBaseConfigAPI (params) {
  return ax({
    url: '/wlapi/baseSetting/getSet',
    method: 'POST',
    data:params
  })
}

/**
 * 敏感词设置   ⬇
 * @param params
 */
/**
 * 敏感词添加   
 */
export function addSensitiveword (params) {
  return ax({
    url: '/wlapi/sensitiveword/addSensitiveword',
    method: 'POST',
    params
  })
}

/**
 * 敏感词列表   
 */
export function sensitivewordList (params) {
  return ax({
    url: '/wlapi/sensitiveword/sensitivewordList',
    method: 'POST',
    params
  })
}

/**
 * 敏感词列表   
 */
export function delSensitiveword (params) {
  return ax({
    url: '/wlapi/sensitiveword/delSensitiveword',
    method: 'POST',
    params
  })
}

/**
 * 留言设置相关   ⬇
 * @param params
 */

export function getLeaveMsgConfigAPI (params) {
  return ax({
    url: '/wlapi/ticketSetting/getTicketSet',
    method: 'GET',
    data:params
  })
}

/**
 * 满意度设置
 * @param params
 * @returns {*}
 */
export function getSatisfactionConfigAPI (params) {
  return ax({
    url: '/wlapi/evaluateSetting/getEvaSet',
    method: 'GET',
    data:params
  })
}

/**
 * 获取评价标签列表展示
 * @param params
 * @returns {*}
 */
export function getEvaluateTagListAPI (params) {
  return ax({
    url: '/wlapi/evaluate/evaluateTagList',
    method: 'POST',
    data:params
  })
}

/**
 * 添加客服评价标签
 * @param params  参数：grade 等级 tagName 标签名
 * @returns {*}
 */
export function addEvaluateTagAPI (params) {
  return ax({
    url: '/wlapi/evaluate/addEvaluateTag',
    method: 'POST',
    params
  })
}

/**
 * 编辑客服评价标签
 * @param params  参数：evaluateTagId id值  tagName 标签名
 * @returns {*}
 */
export function editEvaluateTagAPI (params) {
  return ax({
    url: '/wlapi/evaluate/editEvaluateTag',
    method: 'POST',
    params
  })
}

/**
 * 删除客服评价标签
 * @param params  参数：evaluateTagId  id值
 * @returns {*}
 */
export function delEvaluateTagAPI (params) {
  return ax({
    url: '/wlapi/evaluate/delEvaluateTag',
    method: 'POST',
    params
  })
}

/**
 * 评价标签排序
 * @param params  参数： list 对象 id sort
 * @returns {*}
 */
export function saveEvaluateTagSortsAPI (params) {
  return ax({
    url: '/wlapi/evaluate/saveEvaluateTagSorts',
    method: 'POST',
    params
  })
}

/**
 * 获取快捷引导语列表
 * @param params  
 * @returns {*}
 */
export function getGuideListAPI (params) {
  return ax({
    url: '/wlapi/quickguide/guideList',
    method: 'POST',
    params
  })
}

/**
 * 设置快捷引导语是否展示
 * @param params  guideId isActive 1为显示，0为不显示
 * @returns {*}
 */
export function editGuideActiveAPI (params) {
  return ax({
    url: '/wlapi/quickguide/editGuideActive',
    method: 'POST',
    params
  })
}

/**
 * 添加快捷引导语
 * @param params  guideTag标签名  content链接内容 
 * @returns {*}
 */
export function addGuideAPI (params) {
  return ax({
    url: '/wlapi/quickguide/addQuickGuide',
    method: 'POST',
    params
  })
}

/**
 * 编辑快捷引导语
 * @param params guideId  guideTag标签名  content链接内容 
 * @returns {*}
 */
export function editGuideAPI (params) {
  return ax({
    url: '/wlapi/quickguide/editQuickGuide',
    method: 'POST',
    params
  })
}

/**
 * 删除快捷引导语
 * @param params guideId  
 * @returns {*}
 */
export function delGuideAPI (params) {
  return ax({
    url: '/wlapi/quickguide/delGuide',
    method: 'POST',
    params
  })
}

/**
 * 会话超时
 * @param params
 * @returns {*}
 */
export function getOvertimeConfigAPI (params) {
  return ax({
    url: '/wlapi/sessionSetting/getTimeOutSet',
    method: 'GET',
    data:params
  })
}

/**
 * 消息声音
 * @param params
 * @returns {*}
 */
export function getVoiceListAPI (params) {
  return ax({
    url: '/wlapi/voiceMsg/voiceMsgList',
    method: 'GET',
    data:params
  })
}



/**
 * 自定义消息声音
 * @param params
 * @returns {*}
 */
export function uploadVoiceAPI (params) {
  return ax({
    url: '/wlapi/voiceMsg/upload_music',
    method: 'POST',
    data:params
  })
}

/**
 * 删除-自定义消息声音
 * @param params
 * @returns {*}
 */
export function delCustomVoiceAPI (params) {
  return ax({
    url: '/wlapi/voiceMsg/deleteMusic',
    method: 'POST',
    params
  })
}

/**
 * 排队开关\文案-是否开启
 * @param params
 * @returns {*}
 */
export function getLineupSwitchAPI (params) {
  return ax({
    url: '/wlapi/setting/selectQueueUpSetting',
    method: 'POST',
    params
  })
}
/**
 * 排队开关文案-修改
 * @param params
 * @returns {*}
 */
export function lineupSwitchChangeAPI (params) {
  return ax({
    url: '/wlapi/setting/saveQueueUpSetting',
    method: 'POST',
    params
  })
}


/**
 * 排队开关-切换
 * @param params
 * @returns {*}
 */
export function saveQueuesWitchAPI (params) {
  return ax({
    url: '/wlapi/setting/saveQueuesWitch',
    method: 'POST',
    params
  })
}
/**
 * 排队开关-状态查询
 * @param params
 * @returns {*}
 */
export function selectQueuesWitchAPI (params) {
  return ax({
    url: '/wlapi/setting/selectQueuesWitch',
    method: 'POST',
    params
  })
}


/**
 * 获取-验收提示信息
 * @param params
 * @returns {*}
 */
export function getacceptanceMsgAPI (params) {
  return ax({
    url: '/wlapi/setting/selectAcceptanceMsg',
    method: 'POST',
    params
  })
}

/**
 * 修改-验收提示信息
 * @param params
 * @returns {*}
 */
export function setAcceptanceMsgAPI (params) {
  return ax({
    url: '/wlapi/setting/saveAcceptanceMsg',
    method: 'POST',
    params
  })
}

/**
 * 访客端广告相关-广告图片列表
 * @param params
 * @returns {*}
 */
export function visitorAdPicListAPI (params) {
  return ax({
    url: '/wlapi/visitorPage/adPicturesList',
    method: 'POST',
    params
  })
}


/**
 * 访客端广告相关-广告图片添加
 * @param params
 * @returns {*}
 */
export function visitorAdPicAddAPI (params) {
  return ax({
    url: '/wlapi/visitorPage/addAdPictures',
    method: 'POST',
    params
  })
}

/**
 * 访客端广告相关-广告图片编辑
 * @param params
 * @returns {*}
 */
export function visitorAdPicEditAPI (params) {
  return ax({
    url: '/wlapi/visitorPage/editAdPictures',
    method: 'POST',
    params
  })
}
/**
 * 访客端广告相关-广告图片删除
 * @param params
 * @returns {*}
 */
export function visitorAdPicDelAPI (params) {
  return ax({
    url: '/wlapi/visitorPage/delAdPictures',
    method: 'POST',
    params
  })
}
/**
 * 访客端广告相关-广告图片排序
 * @param params
 * @returns {*}
 */
export function visitorAdPicSortAPI (params) {
  return ax({
    url: '/wlapi/visitorPage/saveAdPicturesSorts',
    method: 'POST',
    data: params
  })
}

/**
 * 访客端自定义小工具相关-获取小工具
 * @param params
 * @returns {*}
 */
export function visitorToolListAPI (params) {
  return ax({
    url: '/wlapi/visitorPage/iconAndLinkList',
    method: 'POST',
    params
  })
}
/**
 * 访客端自定义小工具相关-小工具添加
 * @param params
 * @returns {*}
 */
export function visitorToolAddAPI (params) {
  return ax({
    url: '/wlapi/visitorPage/addIconLink',
    method: 'POST',
    params
  })
}
/**
 * 访客端自定义小工具相关-小工具删除
 * @param params
 * @returns {*}
 */
export function visitorToolDelAPI (params) {
  return ax({
    url: '/wlapi/visitorPage/delIconLink',
    method: 'POST',
    params
  })
}
/**
 * 访客端自定义小工具相关-小工具排序
 * @param params
 * @returns {*}
 */
export function visitorToolSortAPI (params) {
  return ax({
    url: '/wlapi/visitorPage/saveIconLinkSorts',
    method: 'POST',
    data: params
  })
}

/**
 * 访客端自定义小工具相关-小工具编辑
 * @param params
 * @returns {*}
 */
export function visitorToolEditAPI (params) {
  return ax({
    url: '/wlapi/visitorPage/editIconLink',
    method: 'POST',
    params
  })
}

// 会话白名单(防外链)列表
export function externalLinkListAPI (params) {
  return ax({
    url: '/wlapi/externalLink/externalLinkList',
    method: 'POST',
    params
  })
}

// 会话白名单(防外链) 添加编辑
export function saveExternalLinkAPI (params) {
  return ax({
    url: '/wlapi/externalLink/saveExternalLink',
    method: 'POST',
    params
  })
}

// 会话白名单(防外链) 删除
export function delExternalLinkAPI (params) {
  return ax({
    url: '/wlapi/externalLink/delExternalLink',
    method: 'POST',
    data:params
  })
}